import { PossibleHoursRecord, UtcTime } from "modules/Booking/common/interfaces"
import { setUtcHours } from "modules/BookingCommon/common/utils"
import { REG_DATE, REG_TIME_WITH_DURATION } from "modules/Booking/common/constants"
import { getNewUtcDate } from "modules/Booking/common/utils/index"
import { format } from "utils/datetime-format-utils"
import * as utils from "utils/utils"

export const getUtcTime = (slots: PossibleHoursRecord, fromDate: Date, to: Date) => {
    const utcTime: UtcTime = {}

    for (const utcDateStr in slots) {
        const date = utcDateStr.match(REG_DATE)
        if (!date) {
            continue
        }

        const startSessionDateTime = getNewUtcDate(date)

        for (const slot of slots[utcDateStr]) {
            const utcTimeStr = slot.time

            const matchTime = utcTimeStr.match(REG_TIME_WITH_DURATION)

            if (matchTime && matchTime[1] && matchTime[2]) {
                const sessionDateTime = setUtcHours(
                    startSessionDateTime,
                    matchTime[1],
                    matchTime[2]
                )

                const key = format(sessionDateTime, "yyyy/L/d")
                if (!Object.prototype.hasOwnProperty.call(utcTime, key)) {
                    utcTime[key] = []
                }

                const sessionTimeStr = utils.formatLocalTime(sessionDateTime)

                utcTime[key].push(sessionTimeStr)
            }
        }
    }

    const formatFromDate = format(fromDate, "yyyy/L/d")
    if (Object.prototype.hasOwnProperty.call(utcTime, formatFromDate)) {
        delete utcTime[formatFromDate]
    }
    const formatToDate = format(to, "yyyy/L/d")
    if (Object.prototype.hasOwnProperty.call(utcTime, formatToDate)) {
        delete utcTime[formatToDate]
    }

    return utcTime
}
